export const PAGE_TITLE = "مانیتورینگ و گزارش پیامک‌ها";
export const PAGE_SUBTITLE =
  "وضعیت ارسال، هزینه، خطاها و جزئیات پیامک‌های سامانه را در این بخش بررسی کنید.";

export const INTERNAL_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "Pending", label: "در انتظار" },
  { value: "Sent", label: "ارسال شده" },
  { value: "Failed", label: "ناموفق" },
  { value: "BlockedByQa", label: "مسدود شده در حالت تست" },
  { value: "RateLimited", label: "محدود شده" },
  { value: "ProviderAccepted", label: "پذیرفته شده توسط سرویس‌دهنده" },
  { value: "ProviderRejected", label: "رد شده توسط سرویس‌دهنده" },
  { value: "Unknown", label: "نامشخص" },
];

export const PROVIDER_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "ارسال به مخابرات", label: "ارسال به مخابرات" },
  { value: "رسیده به گوشی", label: "رسیده به گوشی" },
  { value: "نرسیده", label: "نرسیده" },
  { value: "شناسه نامعتبر", label: "شناسه نامعتبر" },
  { value: "شماره نامعتبر", label: "شماره نامعتبر" },
  { value: "خطای سرویس‌دهنده", label: "خطای سرویس‌دهنده" },
  { value: "نامشخص", label: "نامشخص" },
];

export const SEND_STATUS_OPTIONS = [
  { value: "", label: "همه" },
  { value: "1", label: "در انتظار" },
  { value: "2", label: "ناموفق" },
  { value: "3", label: "موفق" },
];

export const MONITORING_CATEGORY_LABELS = {
  OTP: "کد تایید / ورود",
  Signup: "ثبت‌نام",
  Workflow: "اطلاع‌رسانی مراحل پروژه",
  Payment: "پرداخت",
  PartnerCommission: "پورسانت نماینده",
  Payout: "تسویه نماینده",
  AdminNotification: "اطلاع‌رسانی مدیریتی",
  General: "عمومی",
};

export const QA_BLOCKED_TOOLTIP =
  "در محیط تست، ارسال واقعی پیامک برای این شماره غیرفعال شده است.";

export const initialFilterValues = {
  mobile: "",
  messageId: "",
  requestId: "",
  referenceId: "",
  smsType: "",
  purpose: "",
  status: "",
  internalStatus: "",
  providerStatus: "",
  minCost: "",
  maxCost: "",
  startDate: "",
  endDate: "",
  pageNumber: 1,
  pageSize: 100,
};
